export const state = () => ({
    beUrl: process.env.NODE_ENV === 'development' ? 'http://192.168.1.66:12107/#' : '/dist/#',
    beDetail: '/supplier/demand/financial-review/form',

    config: {
        newNav: [
            {
                title: '首页',
                href: '/',
                activeReg: /(^\/search*)|(^\/$)/,
                nodeid: 'home',
                id: '1'
            },
            {
                title: '招标信息库',
                id: '2',
                children: [
                    {
                      title: '招标公告公示',
                      href: '/notice',
                      activeReg: /^\/notice/,
                      nodeid: 'notice',
                      id: '20',
                    },
                    {
                        title: '政策法规',
                        href: '/library',
                        activeReg: /^\/library/,
                        nodeid: 'library',
                        id: '21',
                    },
                    {
                        title: '标准规范',
                        href: '/standard',
                        activeReg: /^\/standard/,
                        nodeid: 'standard',
                        id: '22'
                    },
                    {
                        title: '失信名单',
                        href: '/dishonestyRoster',
                        activeReg: /^\/dishonestyRoster/,
                        nodeid: 'dishonestyRoster',
                        id: '51'
                    },
                    {
                        title: '处罚案例',
                        href: '/punishmentCase',
                        activeReg: /^\/punishmentCase/,
                        nodeid: 'punishmentCase',
                        id: '52'
                    },
                ]
            }, {
                title: '招标工具',
                id: '3',
                children: [
                // {
                //     title: '招标采购文件编制',
                //     href: '',
                //     activeReg: /^\/template/,
                //     nodeid: 'template',
                //     click: `getSedToken`,
                //     id: '31'
                // },
                {
                    title: '招标文件审查',
                    href: '',
                    activeReg: /^\/deal-nav\/bid-review/,
                    nodeid: 'bid-review',
                    click: `zbwjReview`,
                    id: '33'
                },
                {
                    title: '招标文件编制',
                    href: '',
                    activeReg: /^\/deal-nav\/purchase-files-generate/,
                    nodeid: 'purchase-files-generate',
                    click: 'purchaseFileGenerate',
                    id: '43'
                },
                // {
                //     title: '便捷工具',
                //     href: '/deal-nav',
                //     activeReg: /^\/deal-nav/,
                //     nodeid: 'deal-nav',
                //     id: '32'
                // },
                // {
                //     title: '商业洞察',
                //     href: '/business-insight',
                //     activeReg: /^\/business-insight/,
                //     nodeid: 'business-insight',
                //     id: '33'
                // },
                {
                    title: '一键发公告',
                    href: '',
                    activeReg: /^\/noticeManage/,
                    nodeid: 'noticeManage',
                    click: `noticeManage`,
                    id: '34'
                },
                {
                    title: '专家抽取',
                    href: '',
                    activeReg: /^\/zjcq-insight/,
                    nodeid: 'zjcq-insight',
                    id: '35'
                },
                {
                    title: '招标代理抽取',
                    href: '',
                    activeReg: /^\/zbdl-insight/,
                    nodeid: 'zbdl-insight',
                    id: '36'
                },
                  {
                    title: '交易中心',
                    href: '/deal-nav/jyzx?province=河北省&city=石家庄市&activeName=jyzx',
                    activeReg: /^\/jyzx/,
                    nodeid: 'jyzx',
                    id: '37',
                  },
                  {
                    title: '第三方平台',
                    href: '/deal-nav/third',
                    activeReg: /^\/third/,
                    nodeid: 'third',
                    id: '40',
                  },
                  {
                    title: 'CA办理',
                    href: '/deal-nav/cabl',
                    activeReg: /^\/cabl/,
                    nodeid: 'cabl',
                    id: '39',
                  },
                  {
                    title: '计费计算器',
                    href: '/deal-nav/calculter',
                    activeReg: /^\/calculter/,
                    nodeid: 'calculter',
                    id: '38'
                  },
                ]
            },
            {
                title: '招标圈子',
                id: '4',
                children: [
                    {
                        title: '每日一问',
                        href: '/everydayQuestion',
                        activeReg: /^\/everydayQuestion/,
                        nodeid: 'everydayQuestion',
                        id: '41'
                    },
                    {
                        title: '课程视频',
                        href: '/video',
                        activeReg: /^\/video/,
                        nodeid: 'video',
                        id: '42'
                    },
                ]
            },
            // {
            //     title: '采购意向',
            //     href: '/caigou',
            //     activeReg: /^\/caigou/,
            //     nodeid: 'caigou',
            // },
            // {
            //     title: '招标数据库',
            //     id: '5',
            //     children: [
            //         {
            //             title: '失信名单',
            //             href: '/dishonestyRoster',
            //             activeReg: /^\/dishonestyRoster/,
            //             nodeid: 'dishonestyRoster',
            //             id: '51'
            //         },
            //         {
            //             title: '处罚案例',
            //             href: '/punishmentCase',
            //             activeReg: /^\/punishmentCase/,
            //             nodeid: 'punishmentCase',
            //             id: '52'
            //         },
            //     ]
            // },
            {
                title: '专家抽取',
                href: '',
                activeReg: /^\/zjcq-insight/,
                nodeid: 'zjcq-insight',
                id: '9',
            },
            {
                title: '一键发公告',
                href: '',
                activeReg: /^\/noticeManage/,
                nodeid: 'noticeManage',
                click: `noticeManage`,
                id: '6'
            },
            {
                title: '智能问答',
                href: '/intelQueAnswer',
                activeReg: /^\/intelQueAnswer/,
                nodeid: 'intelQueAnswer',
                click: ``,
                id: '7'
            },
            {
              title: '商业智能',
              id: '10',
              children: [
                {
                  title: '投资分析',
                  href: '/businessIntelligence/invest',
                  activeReg: /^\/invest/,
                  nodeid: 'invest',
                  click: `businessIntelligence`,
                  id: '1001'
                },
                {
                  title: '招标代理排行榜',
                  href: '/businessIntelligence/agent',
                  activeReg: /^\/agent/,
                  nodeid: 'agent',
                  click: `businessIntelligence`,
                  id: '1002'
                },
                {
                  title: '招标人排行榜',
                  href: '/businessIntelligence/tender',
                  activeReg: /^\/tender/,
                  nodeid: 'tender',
                  click: `businessIntelligence`,
                  id: '1003'
                },
                {
                  title: '主题分析报表',
                  href: '/businessIntelligence/thematic',
                  activeReg: /^\/thematic/,
                  nodeid: 'thematic',
                  click: `businessIntelligence`,
                  id: '1004'
                },
                {
                  title: '中标候选人公示',
                  href: '/businessIntelligence/candidate',
                  activeReg: /^\/candidate/,
                  nodeid: 'candidate',
                  click: `businessIntelligence`,
                  id: '1005'
                },
              ]
            },
            {
              title: '下载',
              href: '/windowsClient',
              activeReg: /^\/windowsClient/,
              nodeid: 'windowsClient',
              click: ``,
              id: '8'
            },
        ],
        nav: [
            {
                title: '首页',
                href: '/',
                activeReg: /(^\/search*)|(^\/$)/,
                nodeid: 'home',
            },
            // {
            //     title: '文件模板',
            //     href: '/document',
            //     activeReg: /^\/document/,
            //     nodeid: 'document',
            // },
            {
                title: '政策法规',
                href: '/library',
                activeReg: /^\/library/,
                nodeid: 'library',
            },
            {
                title: '标准规范',
                href: '/standard',
                activeReg: /^\/standard/,
                nodeid: 'standard',
            },
            {
                title: '发布公告',
                href: '',
                activeReg: /^\/noticeManage/,
                nodeid: 'noticeManage',
                click: `noticeManage`
            },
            {
                title: '招标采购文件编制',
                href: '',
                activeReg: /^\/template/,
                nodeid: 'template',
                click: `getSedToken`
            },
            {
                title: '每日一问',
                href: '/everydayQuestion',
                activeReg: /^\/everydayQuestion/,
                nodeid: 'everydayQuestion',
            },
            {
                title: '课程视频',
                href: '/video',
                activeReg: /^\/video/,
                nodeid: 'video',
            },
            {
                title: '便捷工具',
                href: '/deal-nav',
                activeReg: /^\/deal-nav/,
                nodeid: 'deal-nav',
            },
            {
                title: '商业洞察',
                href: '/business-insight',
                activeReg: /^\/business-insight/,
                nodeid: 'business-insight',
            },
            {
                title: '失信名单',
                href: '/dishonestyRoster',
                activeReg: /^\/dishonestyRoster/,
                nodeid: 'dishonestyRoster',
            },
            {
                title: '处罚案例',
                href: '/punishmentCase',
                activeReg: /^\/punishmentCase/,
                nodeid: 'punishmentCase',
            },
            // {
            //     title: '课程培训',
            //     href: '/class',
            //     click: `showMsgBox('课程培训即将开启，敬请期待！')`,
            //     nodeid: 'class',
            // },
        ],
        tel: '400-901-6886',
        // email: '',
        workTime: '9:00-18:00',
        record: 'ICP备案号：京ICP备2020039654号-8',
        address: '北京市海淀区城西路辅路莲花苑5号 华宝大厦',
        reportEmail: 'hb@zchrkj.com',
        reportTel: '400-901-6886',
        companyAbout: [
            {
                title: '关于我们',
                href: 'http://www.zchrkj.com/pages/about.html'
            },
            {
                title: '法律声明',
                href: 'http://www.zchzb.com/resource-web/pages/companyinfo/index.html?active=1'
            },
            {
                title: '工具下载',
                href: 'http://www.zchzb.com/resource-web/pages/companyinfo/index.html?active=2'
            },
        ],
        products: [
            {
                title: '招标采购交易平台',
                href: 'http://www.zchrkj.com/pages/zhaobiaocaigou.html'
            },
            {
                title: '保函办理平台',
                href: 'http://www.zchrkj.com/pages/baohanbanli.html'
            },
            {
                title: '专家管理平台',
                href: 'http://www.zchrkj.com/pages/zhuanjiaguanli.html'
            },
            {
                title: '线上培训平台',
                href: 'http://www.zchrkj.com/pages/xianshangpeixun.html'
            },
            {
                title: '云咨空间',
                href: 'https://www.yunzikongjian.com'
            },
        ],
    }
})

export const mutations = {

}
